module.exports = __webpack_public_path__ + "img/david_logo2.6a4ed5e4.png";